import { render, staticRenderFns } from "./skills-card-form-audio-play.vue?vue&type=template&id=37fac1c4&"
import script from "./skills-card-form-audio-play.vue?vue&type=script&lang=js&"
export * from "./skills-card-form-audio-play.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports